import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p416862507291983872',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
